import { GuestListButton, GuestListModal, ModalContent } from "./styles";
import GuestListIcon from "../../../../../../Assets/Icons/guest-list.svg";
import useGuestListStore from "../../../../../../stores/useGuestListStore";
import GuestListView from "./GuestListView";
import { useEffect } from "react";
import GuestListAdd from "./GuestListAdd";
import useGetGuestList from "../../../../../../Hooks/useGetGuestList";
import GuestItemDelete from "./GuestItemDelete";

const GuestList = ({ chatId }) => {
  const {
    open,
    isAddingGuest,
    setOpen,
    setIsAddingGuest,
    setIsDeletingGuest,
    setSelectedGuest,
    setGuestList,
    setLoading,
  } = useGuestListStore();

  const { data, loading, getData } = useGetGuestList({
    chatId,
    enabled: !!chatId,
  });

  useEffect(() => {
    if (data) {
      setGuestList(data);
    }
  }, [data, setGuestList]);

  useEffect(() => {
    setLoading(loading);
  }, [loading, setLoading]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleSuccess = () => {
    getData();
  };

  useEffect(() => {
    if (!open) {
      setIsAddingGuest(false);
      setIsDeletingGuest(false);
      setSelectedGuest(null);
    }
  }, [open, setIsAddingGuest, setIsDeletingGuest, setSelectedGuest]);

  return (
    <>
      <GuestListButton onClick={handleOpen}>
        <img src={GuestListIcon} alt="guest-list" />
        Guest List
      </GuestListButton>

      <GuestListModal
        open={open}
        onClose={handleClose}
        disableAutoFocus
        disableRestoreFocus
        disableScrollLock
      >
        <ModalContent>
          {isAddingGuest ? (
            <GuestListAdd chatId={chatId} onSuccess={handleSuccess} />
          ) : (
            <GuestListView />
          )}
        </ModalContent>
      </GuestListModal>

      <GuestItemDelete onSuccess={handleSuccess} />
    </>
  );
};

export default GuestList;
